import { createSlice } from '@reduxjs/toolkit';
import { generateReport } from './aiReportsSlice';

const aiReportHistorySlice = createSlice({
  name: 'aiReportHistory',
  initialState: {
    reports: [], // Array of recent reports
    maxHistory: 10,
  },
  reducers: {
    clearHistory: (state) => {
      state.reports = [];
    },
    removeFromHistory: (state, action) => {
      state.reports = state.reports.filter(
        (report) => report.reportId !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    // Add to history when report generation completes (synchronous response)
    builder.addCase(generateReport.fulfilled, (state, action) => {
      const { report_id, metadata } = action.payload;
      // Get the original query from the thunk argument
      const originalQuery = action.meta?.arg?.query;

      // Check if already exists
      const existingIndex = state.reports.findIndex(
        (r) => r.reportId === report_id
      );

      const reportEntry = {
        reportId: report_id,
        query: originalQuery || metadata?.query || 'Unknown query',
        generatedAt: metadata?.generated_at || new Date().toISOString(),
        recordCount: metadata?.records_processed || metadata?.record_count || 0,
        status: 'completed',
      };

      if (existingIndex !== -1) {
        // Update existing
        state.reports[existingIndex] = reportEntry;
      } else {
        // Add new report to beginning
        state.reports.unshift(reportEntry);

        // Keep only last N reports
        if (state.reports.length > state.maxHistory) {
          state.reports = state.reports.slice(0, state.maxHistory);
        }
      }
    });
  },
});

export const { clearHistory, removeFromHistory } = aiReportHistorySlice.actions;
export default aiReportHistorySlice.reducer;
